import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    modalHeader: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    modalOverlay: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    container: {
        flexDirection: "column",
        flex: 1
    },
    infoCard: {
        flexDirection: "column",
        borderStyle: "solid"
    },
    detailCol: {
        flexDirection: "column",
        flex: 1
    },
    submissionCardContainer: {
        flexDirection: "column",
        borderStyle: "solid",
        width: "100%"
    },
    infoHeader: {
        flexDirection: "column"
    },
    detailSection: {
        flexDirection: "column"
    },
    expandedContent: {
        flexDirection: "column"
    },
    answerRow: {
        flexDirection: "column"
    },
    emptyContainer: {
        alignItems: "center"
    },
    detailRow: {
        flexDirection: "row"
    },
    previewImage: {
        width: 120,
        height: 120
    }
});

export default stylesheet;
